export default __webpack_public_path__ + "svg/logo.bd.svg";